import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const LineChart: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M3 3v18h18' }],
    ['path', { d: 'm19 9-5 5-4-4-3 3' }],
  ],
];

export default LineChart;
